import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  jcbTooltip: 'JCB cards are only accepted on Android devices',
})
